module.exports = flarum.core.compat['components/BasicsPage'];